import { WSTable } from "@wingspanhq/fe-component-library";
import { PayerRow } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { getColumns } from "./columns";

type Props = {
  payers: PayerRow[];
  loading?: boolean;
  onRowClick?: (payer: PayerRow) => void;
};

export const TablePayers: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.payers.map(payer => ({ id: payer.id as string, data: payer })),
    [props.payers]
  );

  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<PayerRow>
      loading={props.loading}
      tableData={tableData}
      columns={columns}
      onRowClick={
        props.onRowClick
          ? rowItem => props.onRowClick!(rowItem.data)
          : undefined
      }
    />
  );
};
